<template>
  <v-dialog v-model="dialogVehicleDetail" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card class="vehicle-popup">
      <v-toolbar>
        <v-btn icon @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-toolbar-title>{{ popupTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="vehicleOrderIDs.length > 0 && !saleRole"
          :loading="exportingDeclaration"
          :disabled="exportingDeclaration"
          color="green darken-1 white--text"
          class="mr-2"
          @click="exportDeclaration"
        >
          <v-icon left>fa-file-excel</v-icon>
          Xuất file khai báo
        </v-btn>
        <v-btn v-if="!readOnly" :disabled="!CorrectData || saving" color="blue darken-1 white--text" @click="saveItem">
          {{ saving ? 'Đang lưu...' : 'Lưu xe hàng' }}
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4 pa-md-6">
        <v-layout row wrap>
          <v-flex xs12>
            <v-card outlined class="pa-4 vehicle-popup__section">
              <v-layout row wrap>
                <v-flex xs12 md4 class="pr-md-3">
                  <v-text-field
                    label="Mã xe hàng"
                    disabled
                    :value="currentItem.VehicleCode || 'Tự sinh sau khi lưu'"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-md-3">
                  <v-text-field
                    label="Biển số xe"
                    v-model="currentItem.LicensePlate"
                    :rules="requireRules"
                    :disabled="readOnly"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="pl-md-3">
                  <v-select
                    label="Trạng thái xe"
                    :items="vehicleStatuses"
                    v-model="currentItem.Status"
                    item-text="name"
                    item-value="value"
                    readonly
                  ></v-select>
                </v-flex>

                <v-flex xs12 md6 class="pr-md-3">
                  <v-autocomplete
                    v-model="currentItem.OrderIDs"
                    :items="orderOptions"
                    item-text="DisplayText"
                    item-value="ID"
                    label="Chọn đơn hàng để xếp xe"
                    chips
                    deletable-chips
                    small-chips
                    multiple
                    clearable
                    :disabled="readOnly"
                    :loading="loadingOrders || syncingPackages"
                    no-data-text="Không có đơn hàng phù hợp để xếp xe"
                    @change="handleSelectionChanged"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 md6 class="pl-md-3">
                  <v-autocomplete
                    v-model="currentItem.BigPackageIDs"
                    :items="bigPackageOptions"
                    item-text="DisplayText"
                    item-value="ID"
                    label="Chọn bao hàng để xếp xe"
                    chips
                    deletable-chips
                    small-chips
                    multiple
                    clearable
                    :disabled="readOnly"
                    :loading="loadingBigPackages || syncingPackages"
                    no-data-text="Không có bao hàng phù hợp để xếp xe"
                    @change="handleSelectionChanged"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 class="vehicle-summary-flex py-2 pr-md-3" v-for="card in summaryCards" :key="card.label">
                  <v-card outlined class="vehicle-summary-card">
                    <div class="vehicle-summary-card__label">{{ card.label }}</div>
                    <div class="vehicle-summary-card__value">{{ card.value }}</div>
                  </v-card>
                </v-flex>

                <v-flex xs12 md4 class="pr-md-3">
                  <v-text-field
                    label="Ngày xếp xe"
                    :value="currentItem.LoadDate | display_date('DD-MM-YYYY HH:mm')"
                    readonly
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="px-md-3">
                  <v-text-field
                    label="Ngày xuất kho"
                    :value="currentItem.ExportDate | display_date('DD-MM-YYYY HH:mm')"
                    readonly
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="pl-md-3">
                  <v-text-field
                    label="Ngày nhập kho"
                    :value="currentItem.ImportDate | display_date('DD-MM-YYYY HH:mm')"
                    readonly
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 class="mt-4">
            <v-card outlined class="vehicle-popup__section">
              <v-card-title class="px-4 py-3 d-flex align-center">
                <span class="subtitle-1 font-weight-bold">Danh sách mã vận đơn</span>
                <v-spacer></v-spacer>
                <v-progress-circular
                  v-if="syncingPackages"
                  indeterminate
                  size="22"
                  width="2"
                  color="primary"
                ></v-progress-circular>
              </v-card-title>
              <v-card-text class="pa-0">
                <div v-if="!groupedTransportSources.length" class="vehicle-popup__empty">
                  Chưa có đơn hàng hoặc bao hàng nào được xếp lên xe.
                </div>
                <div v-else class="vehicle-order-table-wrap">
                  <table class="vehicle-order-table">
                    <thead>
                      <tr>
                        <th>Mã đơn/bao</th>
                        <th>Mã vận đơn</th>
                        <th class="text-right">Cân nặng</th>
                        <th class="text-right">Thể tích</th>
                        <th>Trạng thái</th>
                        <th>Ngày tạo</th>
                        <th class="text-center">Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="group in groupedTransportSources">
                        <tr
                          v-for="(pkg, index) in group.packages"
                          :key="`${group.type}-${group.id}-${pkg.ID || index}`"
                        >
                          <td v-if="index === 0" :rowspan="group.packages.length" class="vehicle-order-table__group">
                            <div class="font-weight-bold">{{ group.code }}</div>
                            <div class="caption grey--text text--darken-1">{{ group.subtitle }}</div>
                            <div class="caption grey--text text--darken-1">
                              {{ group.packages.reduce((acc, pkg) => acc + (Number(pkg.NumberOfPack) || 0), 0) }} kiện · {{ formatNumber(group.totalWeight) }} kg · {{ formatNumber(group.totalVolume) }} m³
                            </div>
                          </td>
                          <td>{{ pkg.TransactionCode || '--' }}</td>
                          <td class="text-right">{{ formatNumber(pkg.Weight) }} kg</td>
                          <td class="text-right">{{ formatNumber(pkg.Volume) }} m³</td>
                          <td>
                            <v-chip small :color="getPackageStatusColor(pkg.Status)" text-color="white">
                              {{ getPackageStatusName(pkg.Status) }}
                            </v-chip>
                          </td>
                          <td>{{ pkg.CreatedDate | display_date('DD-MM-YYYY HH:mm') }}</td>
                          <td v-if="index === 0" :rowspan="group.packages.length" class="text-center">
                            <v-btn
                              small
                              outlined
                              color="red darken-1"
                              :disabled="readOnly"
                              @click="removeGroup(group)"
                            >
                              {{ group.type === 'bigpackage' ? 'Xóa bao' : 'Xóa đơn' }}
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import { sendErrorNotice } from "@/commons/utils";

function createEmptyVehicle() {
  return {
    ID: 0,
    VehicleCode: "",
    LicensePlate: "",
    Status: 0,
    NumberOfPack: 0,
    NumberOfProduct: 0,
    TotalWeight: 0.0,
    TotalVolume: 0.0,
    Orders: [],
    OrderIDs: [],
    AvailableOrders: [],
    BigPackages: [],
    BigPackageIDs: [],
    AvailableBigPackages: [],
    SmallPackages: []
  };
}

export default {
  name: "vehicle-popup",
  props: ["dialogVehicleDetail", "readOnly"],
  data() {
    return {
      requireRules: [v => !!v || "Biển số xe không được để trống."],
      vehicleStatuses: configs.VEHICLE_STATUS,
      packageStatuses: configs.PACKAGE_STATUS,
      loadingOrders: false,
      loadingBigPackages: false,
      syncingPackages: false,
      saving: false,
      exportingDeclaration: false,
      selectionSyncKey: ""
    };
  },
  computed: {
    ...mapState({
      currentItem: state => state.vehicle.selected
    }),
    popupTitle() {
      return this.currentItem.ID > 0
        ? `Chi tiết xe hàng ${this.currentItem.VehicleCode || ""}`
        : "Thêm mới xe hàng";
    },
    CorrectData() {
      return !!(
        this.currentItem.LicensePlate &&
        this.currentItem.LicensePlate.trim() &&
        ((this.currentItem.OrderIDs || []).length > 0 || (this.currentItem.BigPackageIDs || []).length > 0)
      );
    },
    orderOptions() {
      const merged = _.uniqBy(
        [...(this.currentItem.AvailableOrders || []), ...(this.currentItem.Orders || [])],
        "ID"
      );
      return _.map(merged, item => ({
        ...item,
        DisplayText: `${item.OrderCode} - ${item.Username || "Không rõ khách"} - ${item.NumberOfPack || 0} kiện`
      }));
    },
    bigPackageOptions() {
      const merged = _.uniqBy(
        [...(this.currentItem.AvailableBigPackages || []), ...(this.currentItem.BigPackages || [])],
        "ID"
      );
      return _.map(merged, item => ({
        ...item,
        DisplayText: `${item.PackageCode} - ${item.NumberOfPack || 0} kiện`
      }));
    },
    groupedTransportSources() {
      const selectedBigPackageIds = new Set((this.currentItem.BigPackageIDs || []).map(id => Number(id)));
      const ordersById = _.keyBy(this.currentItem.Orders || [], "ID");
      const bigPackagesById = _.keyBy(this.currentItem.BigPackages || [], "ID");
      const byBigPackage = _.chain(this.currentItem.SmallPackages || [])
        .filter(item => selectedBigPackageIds.has(Number(item.BigPackageID)))
        .groupBy(item => item.BigPackageID)
        .map((packages, bigPackageId) => {
          const item = bigPackagesById[bigPackageId] || {};
          return {
            type: "bigpackage",
            id: Number(bigPackageId),
            code: item.PackageCode || packages[0].PackageCode || `#${bigPackageId}`,
            subtitle: "Bao hàng",
            packages,
            totalWeight: _.sumBy(packages, pkg => Number(pkg.Weight) || 0),
            totalVolume: _.sumBy(packages, pkg => Number(pkg.Volume) || 0)
          };
        })
        .orderBy(["id"], ["desc"])
        .value();

      const byOrder = _.chain(this.currentItem.SmallPackages || [])
        .filter(item => !selectedBigPackageIds.has(Number(item.BigPackageID)))
        .groupBy(item => item.OrderID)
        .map((packages, orderId) => {
          const item = ordersById[orderId] || {};
          return {
            type: "order",
            id: Number(orderId),
            code: item.OrderCode || packages[0].OrderCode || `MD${orderId}`,
            subtitle: item.Username || "Đơn hàng",
            packages,
            totalWeight: _.sumBy(packages, pkg => Number(pkg.Weight) || 0),
            totalVolume: _.sumBy(packages, pkg => Number(pkg.Volume) || 0)
          };
        })
        .orderBy(["id"], ["desc"])
        .value();

      return [...byBigPackage, ...byOrder];
    },
    summaryCards() {
      return [
        { label: "Số đơn", value: this.formatInteger((this.currentItem.OrderIDs || []).length) },
        { label: "Số bao", value: this.formatInteger((this.currentItem.BigPackageIDs || []).length) },
        { label: "Số kiện", value: this.formatInteger(_.sumBy(this.currentItem.SmallPackages || [], pkg => Number(pkg.NumberOfPack) || 0)) },
        { label: "Tổng cân", value: `${this.formatNumber(this.currentItem.TotalWeight)} kg` },
        { label: "Tổng khối", value: `${this.formatNumber(this.currentItem.TotalVolume)} m³` }
      ];
    },
    vehicleOrderIDs() {
      if (!this.currentItem) return [];
      const orderIds = _.uniq([
        ...(this.currentItem.OrderIDs || []).map(Number),
        ...(this.currentItem.SmallPackages || []).map(pkg => Number(pkg.OrderID)).filter(Boolean)
      ]);
      return orderIds;
    },
    saleRole() {
      const roleType = Number(this.$store.state.authentication.user.roletype) || 0;
      return (roleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale;
    }
  },
  watch: {
    dialogVehicleDetail: {
      immediate: true,
      handler(value) {
        if (value) {
          this.initializePopup();
        } else {
          this.selectionSyncKey = "";
          this.loadingOrders = false;
          this.loadingBigPackages = false;
          this.syncingPackages = false;
          this.saving = false;
        }
      }
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    initializePopup() {
      if (!this.currentItem || typeof this.currentItem !== "object") {
        this.$store.commit("vehicle/setDetail", { data: createEmptyVehicle() });
        return;
      }

      this.$set(this.currentItem, "Orders", this.currentItem.Orders || []);
      this.$set(this.currentItem, "OrderIDs", _.uniq((this.currentItem.OrderIDs || []).map(id => Number(id)).filter(Boolean)));
      this.$set(this.currentItem, "AvailableOrders", this.currentItem.AvailableOrders || []);
      this.$set(this.currentItem, "BigPackages", this.currentItem.BigPackages || []);
      this.$set(this.currentItem, "BigPackageIDs", _.uniq((this.currentItem.BigPackageIDs || []).map(id => Number(id)).filter(Boolean)));
      this.$set(this.currentItem, "AvailableBigPackages", this.currentItem.AvailableBigPackages || []);
      this.$set(this.currentItem, "SmallPackages", this.currentItem.SmallPackages || []);
      this.refreshAvailableOrders();
      this.refreshAvailableBigPackages();
      this.recalculateTotals();
      this.selectionSyncKey = "";
      this.handleSelectionChanged();
    },
    refreshAvailableOrders() {
      this.loadingOrders = true;
      this.$store.dispatch("vehicle/getAvailableOrders", this.currentItem.ID || 0)
        .then(items => {
          this.$set(this.currentItem, "AvailableOrders", items || []);
          this.syncSelectedOrdersMeta();
        })
        .catch(() => {
          sendErrorNotice("Không tải được danh sách đơn hàng đủ điều kiện xếp xe.");
        })
        .finally(() => {
          this.loadingOrders = false;
        });
    },
    refreshAvailableBigPackages() {
      this.loadingBigPackages = true;
      this.$store.dispatch("vehicle/getAvailableBigPackages", this.currentItem.ID || 0)
        .then(items => {
          this.$set(this.currentItem, "AvailableBigPackages", items || []);
          this.syncSelectedBigPackagesMeta();
        })
        .catch(() => {
          sendErrorNotice("Không tải được danh sách bao hàng đủ điều kiện xếp xe.");
        })
        .finally(() => {
          this.loadingBigPackages = false;
        });
    },
    syncSelectedOrdersMeta() {
      const merged = _.uniqBy(
        [...(this.currentItem.AvailableOrders || []), ...(this.currentItem.Orders || [])],
        "ID"
      );
      const selectedOrders = (this.currentItem.OrderIDs || [])
        .map(id => _.find(merged, { ID: Number(id) }))
        .filter(Boolean);
      this.$set(this.currentItem, "Orders", selectedOrders);
    },
    syncSelectedBigPackagesMeta() {
      const merged = _.uniqBy(
        [...(this.currentItem.AvailableBigPackages || []), ...(this.currentItem.BigPackages || [])],
        "ID"
      );
      const selectedBigPackages = (this.currentItem.BigPackageIDs || [])
        .map(id => _.find(merged, { ID: Number(id) }))
        .filter(Boolean);
      this.$set(this.currentItem, "BigPackages", selectedBigPackages);
    },
    buildSelectionSyncKey(orderIds, bigPackageIds) {
      const orderKey = _.sortBy(orderIds || []).join(",");
      const packageKey = _.sortBy(bigPackageIds || []).join(",");
      return `${orderKey}::${packageKey}`;
    },
    handleSelectionChanged() {
      const orderIds = _.uniq((this.currentItem.OrderIDs || []).map(id => Number(id)).filter(Boolean));
      const bigPackageIds = _.uniq((this.currentItem.BigPackageIDs || []).map(id => Number(id)).filter(Boolean));
      const nextKey = this.buildSelectionSyncKey(orderIds, bigPackageIds);

      this.$set(this.currentItem, "OrderIDs", orderIds);
      this.$set(this.currentItem, "BigPackageIDs", bigPackageIds);
      this.syncSelectedOrdersMeta();
      this.syncSelectedBigPackagesMeta();

      if (nextKey === this.selectionSyncKey) {
        this.recalculateTotals();
        return;
      }
      this.selectionSyncKey = nextKey;

      if (!orderIds.length && !bigPackageIds.length) {
        this.$set(this.currentItem, "SmallPackages", []);
        this.recalculateTotals();
        return;
      }

      this.syncingPackages = true;
      Promise.all([
        orderIds.length ? this.$store.dispatch("vehicle/getOrderPackages", orderIds) : Promise.resolve([]),
        bigPackageIds.length ? this.$store.dispatch("vehicle/getBigPackagePackages", bigPackageIds) : Promise.resolve([])
      ]).then(([orderPackages, bigPackagePackages]) => {
        const mergedPackages = _.uniqBy([...(bigPackagePackages || []), ...(orderPackages || [])], "ID");
        this.$set(this.currentItem, "SmallPackages", mergedPackages);
        this.recalculateTotals();
      }).catch(() => {
        sendErrorNotice("Không tải được danh sách mã vận đơn của các đơn hàng/bao hàng đã chọn.");
      }).finally(() => {
        this.syncingPackages = false;
      });
    },
    removeGroup(group) {
      if (group.type === "bigpackage") {
        this.$set(this.currentItem, "BigPackageIDs", _.without(this.currentItem.BigPackageIDs || [], Number(group.id)));
      } else {
        this.$set(this.currentItem, "OrderIDs", _.without(this.currentItem.OrderIDs || [], Number(group.id)));
      }
      this.handleSelectionChanged();
    },
    recalculateTotals() {
      const packages = this.currentItem.SmallPackages || [];
      this.currentItem.NumberOfPack = _.sumBy(packages, pkg => Number(pkg.NumberOfPack) || 0);
      this.currentItem.NumberOfProduct = packages.length;
      this.currentItem.TotalWeight = _.sumBy(packages, pkg => Number(pkg.Weight) || 0);
      this.currentItem.TotalVolume = _.sumBy(packages, pkg => Number(pkg.Volume) || 0);
    },
    getPackageStatusColor(status) {
      const match = _.find(this.packageStatuses, { value: status });
      return match ? match.color : "grey";
    },
    getPackageStatusName(status) {
      const match = _.find(this.packageStatuses, { value: status });
      return match ? match.name : "Không xác định";
    },
    formatNumber(value) {
      return (Number(value) || 0).toLocaleString("vi-VN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
    formatInteger(value) {
      return (Number(value) || 0).toLocaleString("vi-VN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    },
    saveItem() {
      this.recalculateTotals();
      this.saving = true;
      this.$store.dispatch("vehicle/setDetail", {
        data: {
          ...this.currentItem,
          OrderIDs: this.currentItem.OrderIDs || [],
          BigPackageIDs: this.currentItem.BigPackageIDs || []
        },
        id: this.currentItem.ID
      }).then(() => {
        this.closePopup();
      }).finally(() => {
        this.saving = false;
      });
    },
    exportDeclaration() {
      if (this.exportingDeclaration) {
        return;
      }
      const orderIds = this.vehicleOrderIDs;
      if (orderIds.length === 0) {
        sendErrorNotice("Không có đơn hàng nào trên xe để xuất file khai báo.");
        return;
      }
      this.exportingDeclaration = true;
      this.$store.dispatch("declaration/exportDeclaration", {
        order_ids: orderIds.join(","),
        vehicle_code: this.currentItem.VehicleCode || ""
      }).finally(() => {
        this.exportingDeclaration = false;
      });
    }
  }
};
</script>

<style scoped>
.vehicle-popup {
  background: #f5f7fb;
}

.vehicle-popup__section {
  border-radius: 16px;
  background: #fff;
}

.vehicle-summary-flex {
  width: 100%;
}

@media (min-width: 960px) {
  .vehicle-summary-flex {
    flex: 0 0 20% !important;
    max-width: 20% !important;
  }
}

.vehicle-summary-card {
  padding: 18px 16px;
  min-height: 104px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f7fafc 0%, #eef3ff 100%);
}

.vehicle-summary-card__label {
  font-size: 13px;
  color: #5f6b7a;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.vehicle-summary-card__value {
  font-size: 22px;
  font-weight: 700;
  color: #1f2d3d;
}

.vehicle-popup__empty {
  padding: 40px 16px;
  text-align: center;
  color: #7a8796;
}

.vehicle-order-table-wrap {
  overflow-x: auto;
}

.vehicle-order-table {
  width: 100%;
  border-collapse: collapse;
}

.vehicle-order-table th,
.vehicle-order-table td {
  padding: 12px 14px;
  border-top: 1px solid #e6ebf2;
  vertical-align: top;
  font-size: 14px;
}

.vehicle-order-table th {
  background: #f8fafc;
  color: #445165;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
}

.vehicle-order-table__group {
  min-width: 200px;
  background: #fcfdff;
}

@media (max-width: 960px) {
  .vehicle-summary-card {
    min-height: auto;
  }

  .vehicle-order-table th,
  .vehicle-order-table td {
    padding: 10px 12px;
  }
}
</style>
